import { render, staticRenderFns } from "./ConfirmBuy.vue?vue&type=template&id=5412ba3e&scoped=true"
import script from "./ConfirmBuy.vue?vue&type=script&lang=js"
export * from "./ConfirmBuy.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBuy.vue?vue&type=style&index=0&id=5412ba3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412ba3e",
  null
  
)

export default component.exports